/**
 * Personal band above the footer (SJ 12.09.2026; r154 = all six personalization picks).
 *
 * Rows, in this order, each only when it has data:
 *   1. „Weil Sie „…" angesehen haben"   Shopify's own recommendations (related intent), seeded by the
 *                                       last viewed product, minus everything already seen or saved.
 *                                       r155 (SJ 12.09 15:25): only the seed's gender, only pieces that
 *                                       come in the remembered size, at least 4 — or no row at all.
 *   2. „Dazu passend zu Ihrem Kauf"     account holders: the worker's /storefront/orders returns the
 *                                       newest purchases (handles, ids, sizes); recommendations seeded
 *                                       by the newest one, minus the purchases themselves (same filters).
 *   3. „Aus Ihrer Merkliste"            wishlist.js' own store (goessl_wishlist, read-only here) with
 *                                       the „Preis gesenkt" / „Wieder verfügbar" alert badges.
 *   4. „Ihr Gwandhaus"                  the favourite store (goessl:favStore) rendered through
 *                                       sections/gwandhaus-card-2026.liquid on the store's own page.
 *   5. „Zuletzt angesehen"              localStorage goessl_recent = [{h, t, i}] newest first (cap 24);
 *                                       account holders sync to the cron-jobs worker (/storefront/recent, KV)
 *                                       so the row — and the size memory — follow them across devices.
 *                                       09.10.2026 (SJ: "like on Amazon"): a small picture strip and the
 *                                       band's LAST row on every page - what the visitor has seen is a way
 *                                       back, the large cards belong to what they have not seen yet. Its
 *                                       items come from the section's mini pool (picture + title, no card).
 *
 * Rendering: the card pool comes from the Section Rendering API (search route for
 * handles, recommendations route for the two rails), every card through the shared
 * card-product snippet; the strip's mini pool comes from the same search route ('g26rvm').
 * All fetches run in parallel, the band is assembled once and shown once — never in pieces.
 * window.GoesslPersonal (g26-personal.js) adds the „In Ihrer Größe" notes and alert badges after assembly.
 */
(function () {
  'use strict';

  var KEY = 'goessl_recent';
  var WISH_KEY = 'goessl_wishlist';
  var MAX_STORE = 24, MAX_RECENT = 12, MAX_WISH = 8, MAX_RECS = 8, MIN_ROW = 4;
  var API = 'https://goessl-cron-jobs.asksj.workers.dev/storefront/recent';
  var API_ORDERS = 'https://goessl-cron-jobs.asksj.workers.dev/storefront/orders';

  var shell = document.querySelector('[data-g26-recent]');
  if (!shell) return;

  var sectionId = shell.getAttribute('data-rv-section') || 'recently-viewed-2026';
  var current = shell.getAttribute('data-rv-current') || '';
  var currentId = shell.getAttribute('data-rv-current-id') || '';
  var hideWishlist = shell.getAttribute('data-rv-hide-wishlist') === '1';
  var P = window.GoesslPersonal || null;

  function attr(name, fallback) { return shell.getAttribute(name) || fallback; }

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY)) || [];
      return Array.isArray(a) ? a.filter(function (x) { return x && typeof x.h === 'string' && x.h; }) : [];
    } catch (e) { return []; }
  }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX_STORE))); } catch (e) {} }
  // union by handle, newest timestamp wins, product id carried along, newest first
  function merge(a, b) {
    var m = {};
    a.concat(b).forEach(function (x) {
      if (!x || typeof x.h !== 'string' || !x.h) return;
      var t = Number(x.t) || 0;
      var cur = m[x.h];
      if (!cur) m[x.h] = { h: x.h, t: t, i: x.i || '' };
      else {
        if (t > cur.t) cur.t = t;
        if (!cur.i && x.i) cur.i = x.i;
      }
    });
    return Object.keys(m).map(function (h) { return m[h]; })
      .sort(function (x, y) { return y.t - x.t; }).slice(0, MAX_STORE);
  }
  function customer() { return (window.Goessl && window.Goessl.customer) || null; }
  function wishHandles() {
    try {
      var a = JSON.parse(localStorage.getItem(WISH_KEY)) || [];
      return Array.isArray(a) ? a.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }

  // 1) record this product view
  var list = read();
  var viewed = false;
  if (current) { list = merge([{ h: current, t: Date.now(), i: currentId }], list); write(list); viewed = true; }

  // 2) logged-in: merge the server copy (views + size memory), push back when this
  //    page added a view or the local copy carried something the server lacked
  function sync() {
    var c = customer();
    if (!c || !c.id) return Promise.resolve(list);
    return fetch(API + '?shopify_customer_id=' + encodeURIComponent(c.id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var server = (j && Array.isArray(j.items)) ? j.items : [];
        if (P && j && j.sizes) P.sizes.merge(j.sizes);
        var merged = merge(list, server);
        var changed = viewed || merged.length !== server.length;
        list = merged; write(list);
        if (changed || (P && j && !j.sizes && Object.keys(P.sizes.all()).length)) {
          fetch(API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ shopify_customer_id: c.id, email: c.email, items: list, sizes: P ? P.sizes.all() : undefined })
          }).catch(function () {});
        }
        return list;
      })
      .catch(function () { return list; });
  }

  // 3) logged-in: newest purchases (for the „Dazu passend" rail + sizes learned from orders)
  function orders() {
    var c = customer();
    if (!c || !c.id || !c.email) return Promise.resolve(null);
    return fetch(API_ORDERS + '?shopify_customer_id=' + encodeURIComponent(c.id) + '&email=' + encodeURIComponent(c.email))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return null;
        if (P && j.sizes) P.sizes.merge(j.sizes);
        return j;
      })
      .catch(function () { return null; });
  }

  var ARROW_PREV = '<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>';
  var ARROW_NEXT = '<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function buildRow(title, items, link, kicker) {
    var sec = document.createElement('section');
    sec.className = 'g26-slider g26-section';
    sec.setAttribute('data-g26-slider', '');
    var head = document.createElement('div');
    head.className = 'g26-slider__head page-width';
    if (kicker) {
      var k = document.createElement('span');
      k.className = 'g26-slider__kicker';
      k.textContent = kicker;
      head.appendChild(k);
    }
    var row = document.createElement('div');
    row.className = 'g26-slider__title-row';
    var h2 = document.createElement('h2');
    h2.className = 'g26-slider__title';
    h2.textContent = title;
    var arrows = document.createElement('div');
    arrows.className = 'g26-slider__arrows';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'g26-slider__arrow'; prev.setAttribute('data-g26-prev', ''); prev.setAttribute('aria-label', window.g26tText('general.pagination.previous', 'Zurück')); prev.innerHTML = ARROW_PREV;
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'g26-slider__arrow'; next.setAttribute('data-g26-next', ''); next.setAttribute('aria-label', window.g26tText('general.pagination.next', 'Weiter')); next.innerHTML = ARROW_NEXT;
    arrows.appendChild(prev); arrows.appendChild(next);
    row.appendChild(h2); row.appendChild(arrows);
    if (link) {
      var a = document.createElement('a');
      a.href = link.href; a.className = 'g26-slider__link link-underline'; a.textContent = link.label;
      row.appendChild(a);
    }
    head.appendChild(row);
    var track = document.createElement('div');
    track.className = 'g26-slider__track';
    track.setAttribute('data-g26-track', '');
    items.forEach(function (el) { track.appendChild(el); });
    sec.appendChild(head); sec.appendChild(track);
    return sec;
  }

  // „Zuletzt angesehen" as a small strip: heading in small caps, arrows on wide screens, a plain scrolling list
  function buildStrip(title, items) {
    var sec = document.createElement('section');
    sec.className = 'g26-strip';
    sec.setAttribute('data-g26-strip', '');
    var head = document.createElement('div');
    head.className = 'g26-strip__head';
    var h2 = document.createElement('h2');
    h2.className = 'g26-strip__heading';
    h2.textContent = title;
    var arrows = document.createElement('div');
    arrows.className = 'g26-strip__arrows';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'g26-strip__arrow'; prev.setAttribute('aria-label', window.g26tText('general.pagination.previous', 'Zurück')); prev.innerHTML = ARROW_PREV;
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'g26-strip__arrow'; next.setAttribute('aria-label', window.g26tText('general.pagination.next', 'Weiter')); next.innerHTML = ARROW_NEXT;
    arrows.appendChild(prev); arrows.appendChild(next);
    head.appendChild(h2); head.appendChild(arrows);
    var track = document.createElement('ul');
    track.className = 'g26-strip__track';
    track.setAttribute('role', 'list');
    items.forEach(function (el) {
      var li = document.createElement('li');
      li.className = 'g26-strip__cell';
      li.appendChild(el);
      track.appendChild(li);
    });
    sec.appendChild(head); sec.appendChild(track);
    var update = function () {
      // no arrows when every picture fits (two greyed arrows over five pictures only add noise)
      arrows.hidden = track.scrollWidth <= track.clientWidth + 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    prev.addEventListener('click', function () { track.scrollBy({ left: -Math.max(track.clientWidth * 0.8, 120), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: Math.max(track.clientWidth * 0.8, 120), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    sec._g26Update = update;
    return sec;
  }

  function parsePool(html) {
    var pool = {};
    if (!html) return pool;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('[data-rv-handle]').forEach(function (el) { pool[el.getAttribute('data-rv-handle')] = el; });
    return pool;
  }
  function fetchText(url) {
    return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
  }
  // the search-route pool for a list of handles → { handle: element }
  function fetchHandlePool(handles) {
    if (!handles.length) return Promise.resolve({});
    var q = 'g26rv ' + handles.slice(0, 20).join(' ');
    return fetchText(window.g26url('search') + '?q=' + encodeURIComponent(q) + '&type=product&section_id=' + encodeURIComponent(sectionId)).then(parsePool);
  }
  // the strip's mini pool (picture + title per handle) → { handle: element }
  function fetchMiniPool(handles) {
    if (!handles.length) return Promise.resolve({});
    var q = 'g26rvm ' + handles.slice(0, 20).join(' ');
    return fetchText(window.g26url('search') + '?q=' + encodeURIComponent(q) + '&type=product&section_id=' + encodeURIComponent(sectionId)).then(parsePool);
  }
  // Shopify recommendations for one product id → ordered [{h, el}]
  function fetchRecs(productId) {
    if (!productId) return Promise.resolve([]);
    var url = window.g26url('recommendations/products') + '?section_id=' + encodeURIComponent(sectionId) + '&product_id=' + encodeURIComponent(productId) + '&limit=10&intent=related';
    return fetchText(url).then(function (html) {
      if (!html) return [];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.from(doc.querySelectorAll('[data-rv-handle]')).map(function (el) { return { h: el.getAttribute('data-rv-handle'), el: el }; });
    });
  }
  // The route answers 404 for products that are not on the Online Store (till-only
  // purchases, unpublished pieces), so walk the seeds in order until one yields cards.
  function fetchRecsForSeeds(seeds, resolve) {
    var list = (seeds || []).filter(Boolean).slice(0, 3);
    var i = 0;
    function next() {
      if (i >= list.length) return Promise.resolve({ seed: null, recs: [] });
      var seed = list[i++];
      return (resolve ? resolve(seed) : Promise.resolve(String(seed.i || ''))).then(fetchRecs).then(function (recs) {
        return recs.length ? { seed: seed, recs: recs } : next();
      });
    }
    return next();
  }
  // product id for a handle that was recorded before ids were stored
  function resolveId(entry) {
    if (!entry) return Promise.resolve('');
    if (entry.i) return Promise.resolve(String(entry.i));
    return fetch(window.g26url('products/' + encodeURIComponent(entry.h) + '.js'))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.id) { entry.i = String(p.id); write(list); return entry.i; }
        return '';
      })
      .catch(function () { return ''; });
  }
  function titleOf(el) {
    var t = el && el.querySelector('.goessl-product-card__title');
    return t ? t.textContent.trim() : '';
  }
  function cardOf(el) { return el ? el.querySelector('article.goessl-product-card') : null; }
  function genderOfEl(el) { var c = cardOf(el); return c ? (c.getAttribute('data-gender') || '') : ''; }
  // the strip's mini items carry the same gender letter and title as a card (r155: the „Weil Sie" seed keeps its gender)
  function genderOfMini(el) { return el ? (el.getAttribute('data-gender') || '') : ''; }
  function miniTitleOf(el) { var t = el && el.querySelector('.g26-strip__title'); return t ? t.textContent.trim() : ''; }
  function shortTitle(t) { return t.length > 42 ? t.slice(0, 40).replace(/\s+\S*$/, '') + '…' : t; }
  function favSlug() {
    var v = null;
    try { v = (window.GoesslFavStore && window.GoesslFavStore.get()) || localStorage.getItem('goessl:favStore'); } catch (e) {}
    return v ? String(v).replace(/^\/pages\//, '').replace(/[^a-z0-9-]/gi, '') : '';
  }
  function fetchStoreCard(slug) {
    if (!slug) return Promise.resolve(null);
    return fetchText(window.g26url('pages/' + encodeURIComponent(slug)) + '?section_id=gwandhaus-card-2026').then(function (html) {
      if (!html) return null;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var card = doc.querySelector('[data-gw-card]');
      return card ? card.cloneNode(true) : null;
    });
  }

  var rendered = false;
  function render(orderData) {
    if (rendered) return;
    var recent = list.filter(function (x) { return x.h !== current; }).slice(0, MAX_RECENT);
    var recentHandles = recent.map(function (x) { return x.h; });
    var wish = hideWishlist ? [] : wishHandles().slice(0, MAX_WISH);
    var purchased = [];
    var orderSeeds = [];
    if (orderData && Array.isArray(orderData.orders)) {
      orderData.orders.forEach(function (o) {
        (o.items || []).forEach(function (it) {
          if (it && it.h && purchased.indexOf(it.h) === -1) purchased.push(it.h);
          if (it && it.h && it.i) orderSeeds.push(it);
        });
      });
    }
    var fav = favSlug();
    if (!recentHandles.length && !wish.length && !orderSeeds.length && !fav && !currentId) return;
    rendered = true;

    // full cards only for the wishlist row; the recent strip takes the mini pool
    var poolHandles = wish.slice();

    // seeds for the „Weil Sie …" rail: the newest views that are not this page; on a
    // product page without history the product itself seeds the rail
    var recentSeeds = recent.slice(0, 3);
    if (!recentSeeds.length && currentId) recentSeeds = [{ h: current, i: currentId }];

    Promise.all([
      fetchHandlePool(poolHandles),
      fetchRecsForSeeds(recentSeeds, resolveId),
      fetchRecsForSeeds(orderSeeds),
      fetchStoreCard(fav),
      fetchMiniPool(recentHandles)
    ]).then(function (res) {
      var pool = res[0], storeCard = res[3], mini = res[4];
      var seedRecent = res[1].seed, recsRecent = res[1].recs;
      var seedOrder = res[2].seed, recsOrder = res[2].recs;
      var pick = function (hs) {
        var out = [];
        hs.forEach(function (h) { if (pool[h]) out.push(pool[h].cloneNode(true)); });
        return out;
      };
      var used = {};
      var mark = function (hs) { hs.forEach(function (h) { used[h] = true; }); };
      mark([current]); mark(recentHandles); mark(wish); mark(purchased);

      var recentItems = [];
      recentHandles.forEach(function (h) { if (mini[h]) recentItems.push(mini[h].cloneNode(true)); });
      var frag = document.createDocumentFragment();

      // r155: a rail keeps only the seed's gender and only pieces that come in the
      // remembered size; fewer than MIN_ROW → no rail (handles stay free for the next one)
      var takeRecs = function (recs, seedGender) {
        var out = [], hs = [];
        recs.forEach(function (r) {
          if (out.length >= MAX_RECS || used[r.h] || hs.indexOf(r.h) !== -1) return;
          var card = cardOf(r.el);
          if (P && (!P.genderFits(seedGender, card && card.getAttribute('data-gender')) || !P.sizes.fits(card))) return;
          hs.push(r.h);
          out.push(r.el.cloneNode(true));
        });
        if (out.length < MIN_ROW) return [];
        mark(hs);
        // house rule (SJ 26.08): a sale piece never opens a list - Shopify's relevance order, sale pieces behind the rest
        var onSale = function (el) { var c = cardOf(el); return !!c && c.getAttribute('data-on-sale') === 'true'; };
        return out.filter(function (el) { return !onSale(el); }).concat(out.filter(onSale));
      };
      var seedRecentGender = seedRecent ? (genderOfEl(pool[seedRecent.h]) || (seedRecent.h === current ? attr('data-rv-current-gender', '') : '') || genderOfMini(mini[seedRecent.h])) : '';
      var becauseItems = takeRecs(recsRecent, seedRecentGender);
      if (becauseItems.length && seedRecent) {
        var seedTitle = titleOf(pool[seedRecent.h]) || miniTitleOf(mini[seedRecent.h]) || (seedRecent.h === current ? (document.querySelector('.g26-pdp__title') || {}).textContent : '') || '';
        seedTitle = String(seedTitle || '').trim();
        var tpl = attr('data-rv-heading-because', window.g26tText('products.recently_viewed.heading_because', 'Weil Sie „{{ title }}“ angesehen haben', { title: '%s' }));
        var title = seedTitle ? tpl.replace('%s', shortTitle(seedTitle)) : window.g26t('products.recently_viewed.heading_suggested', 'Das könnte Ihnen gefallen');
        frag.appendChild(buildRow(title, becauseItems, null));
      }
      var purchaseItems = takeRecs(recsOrder, seedOrder && seedOrder.fam ? String(seedOrder.fam).split(':')[0] : '');
      if (purchaseItems.length && seedOrder) {
        var kick = attr('data-rv-kicker-purchase', window.g26t('products.recently_viewed.kicker_purchase', 'Zu Ihrer Bestellung: {{ title }}', { title: '%s' })).replace('%s', shortTitle(String(seedOrder.title || seedOrder.h)));
        frag.appendChild(buildRow(attr('data-rv-heading-purchase', window.g26t('products.recently_viewed.heading_purchase', 'Dazu passend zu Ihrem Kauf')), purchaseItems, null, kick));
      }
      var wishItems = pick(wish);
      if (wishItems.length) frag.appendChild(buildRow(attr('data-rv-heading-wishlist', window.g26t('products.recently_viewed.heading_wishlist', 'Aus Ihrer Merkliste')), wishItems, {
        href: attr('data-rv-wishlist-url', window.g26url('pages/wishlist')),
        label: attr('data-rv-wishlist-link', window.g26t('customer.account.wishlist_link', 'Zur Merkliste'))
      }));
      if (storeCard) frag.appendChild(storeCard);
      // the strip closes the band (09.10.2026), on the product page right above the footer
      var strip = recentItems.length ? buildStrip(attr('data-rv-heading-recent', window.g26t('products.recently_viewed.heading_recent', 'Zuletzt angesehen')), recentItems) : null;
      if (strip) frag.appendChild(strip);

      if (!frag.childNodes.length) { rendered = false; return; }
      shell.innerHTML = '';
      shell.appendChild(frag);
      shell.hidden = false;
      if (typeof window.g26InitSlider === 'function') {
        shell.querySelectorAll('[data-g26-slider]').forEach(function (s) { window.g26InitSlider(s); });
      }
      if (strip && strip._g26Update) strip._g26Update();
      if (window.Goessl && window.Goessl.wishlist && window.Goessl.wishlist.updateUI) window.Goessl.wishlist.updateUI();
      if (window.GoesslFavStore && window.GoesslFavStore.paint) window.GoesslFavStore.paint();
      if (P && P.decorate) P.decorate(shell);
    }).catch(function () { rendered = false; });
  }

  // the favourite star inside the store card: un-starring removes the card
  document.addEventListener('favstore:change', function (e) {
    var card = shell.querySelector('[data-gw-card]');
    if (!card) return;
    var fav = e.detail && e.detail.fav;
    if (!fav || fav !== card.getAttribute('data-gw-slug')) {
      card.remove();
      if (!shell.querySelector('[data-g26-slider]')) shell.hidden = true;
    }
  });

  // Render lazily: when the band comes within 800px of the viewport (or after 3 s),
  // after the account sync + order lookup settled — the page's own content loads first.
  function start() {
    var kicked = false;
    var go = function () {
      if (kicked) return; kicked = true;
      Promise.all([sync(), orders()]).then(function (r) { render(r[1]); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
      }, { rootMargin: '800px 0px' });
      io.observe(shell);
    }
    setTimeout(go, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
